import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const StepperNumbers = styled(Box)(({ theme }) => ({
  background: theme.palette.neutrals.beige3,
  borderRadius: 4
}));

export default StepperNumbers;
